/**
 * Téléchargement de l'application mobile.
 *
 * Le fichier vit dans `client/public/` et non dans `src/` : webpack ne doit
 * pas le traiter, il est simplement recopié tel quel dans le build. Il est
 * exclu de git (`*.apk` dans le .gitignore) — 208 Mo n'ont rien à faire dans
 * un dépôt, et GitHub refuse les fichiers de plus de 100 Mo.
 *
 * En production, `REACT_APP_APK_URL` permet de le servir depuis ailleurs
 * (Firebase Storage, un CDN, ou le Play Store une fois l'appli publiée) sans
 * toucher au code : c'est la seule chose à changer.
 */

export const APK_URL = process.env.REACT_APP_APK_URL || '/vadom_app.apk';

/** Nom du fichier proposé au visiteur, indépendant de celui sur le serveur. */
export const APK_FILENAME = 'vadom.apk';

/**
 * 78 347 959 octets. Affiché pour prévenir avant un téléchargement long.
 *
 * Build de production, signé avec `upload-keystore.jks` et limité aux deux
 * architectures réelles :
 *   flutter build apk --release --target-platform android-arm,android-arm64
 *
 * Ne pas repartir de `app-debug.apk` : il pèse 208 Mo, embarque le code Dart
 * non compilé et tourne nettement plus lentement.
 */
export const APK_SIZE_LABEL = '75 Mo';

/** L'APK ne concerne qu'Android : sur iOS, le fichier est inutilisable. */
export const isIOS = () =>
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ se présente comme un Mac, mais avec un écran tactile
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
